import { render, staticRenderFns } from "./CustomDashDateRange.vue?vue&type=template&id=52b00796&scoped=true"
import script from "./CustomDashDateRange.vue?vue&type=script&lang=js"
export * from "./CustomDashDateRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b00796",
  null
  
)

export default component.exports